module.exports = __webpack_public_path__ + "img/12.859b3912.png";